import React from 'react';
import Header from '../components/sections/Header';
import Footer from '../components/sections/Footer';
import SEOHead from '../components/SEOHead';
import WhatsAppButton from '../components/WhatsAppButton';

const PageLayout = ({ children, pageSlug, customTitle, customDescription }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <SEOHead pageSlug={pageSlug} customTitle={customTitle} customDescription={customDescription} />
      <Header />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default PageLayout;
